import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import Scene360Hotspot from '../360_react/Scene360Hotspot';
import Urls from '../urls/Urls';
import EulerAngles from '../geometry/EulerAngles';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class HotspotOutside360Move extends Scene360Hotspot{
	constructor(props){
		super(props);
		this._rotateToCompensate = true;
		const {outside360ToMoveToUniqueId}=props;
		if(outside360ToMoveToUniqueId===undefined||outside360ToMoveToUniqueId===null)
			throwNotProvided('outside360ToMoveToUniqueId');
		this._outside360ToMoveToUniqueId = outside360ToMoveToUniqueId;
	}
	get fromFactory(){
		return false;
	}
	get outside360ToMoveToUniqueId(){
		return this._outside360ToMoveToUniqueId;
	}
	get className(){
		return 'move-hotspots';
	}
	static fromJSON(jObject){
		return new HotspotOutside360Move({
			iconRelativePath:jObject.iconRelativePath,
			type:jObject.type,
			eulerAngles:EulerAngles.fromJSON(jObject.eulerAngles),
			pointingAtEulerAngles:jObject.pointingAtEulerAngles?EulerAngles.fromJSON(jObject.pointingAtEulerAngles):null,
			outside360ToMoveToUniqueId:jObject.outside360ToMoveToUniqueId
		});
	}
}